export default (originalComponent: any) => {
    const JsxText = (props: any) =>
        originalComponent({
            ...props,
            transformers: ['jsx']
        });

    return JsxText;
};
